import React from 'react';
import { AnalyticsSource } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import { ErrorFlagRenderer } from '@atlassian/jira-error-boundary-flag-renderer/src/ErrorBoundaryFlag.tsx';
import ReportErrors from '@atlassian/jira-errors-handling/src/utils/reporting-error-boundary.tsx';
import FiltersApp from '@atlassian/jira-filters-main/src/index.tsx';
import { SCREEN } from '@atlassian/jira-product-analytics-bridge';
import {
	appBundleReadyMark,
	prefetchApiReadyMark,
} from '@atlassian/jira-providers-spa-apdex-analytics/src/marks.tsx';
import SubmitApdex from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/index.tsx';
import { toAccountId } from '@atlassian/jira-shared-types/src/general.tsx';
import { FiltersDirectorySkeleton } from '@atlassian/jira-skeletons/src/ui/directories/FiltersDirectorySkeleton.tsx';
import { PageLayout } from '@atlassian/jira-spa-apps-page-layout/src/page/index.tsx';
import { filtersDirectoryPageLoad } from '../utils/performance-analytics/index.tsx';
import type { Props } from './types.tsx';

// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

function FiltersDirectory({
	Updater,
	tenantContext,
	prefetchResult,
	favoriteChangeContext,
	query,
	onQueryChanged,
}: Props): React.JSX.Element {
	const { xsrfToken, atlassianAccountId } = tenantContext;
	const { error: prefetchError, loading, data } = prefetchResult;

	if (prefetchError && !loading) {
		// @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error)' is not assignable to type 'Error | null'.
		return <ErrorFlagRenderer id="directories-filters" error={prefetchError} />;
	}
	if (!data) {
		return <FiltersDirectorySkeleton />;
	}
	return (
		<PageLayout>
			<ReportErrors id="unhandled" packageName="jiraSpaAppsDirectoriesFilters" teamName="keystone">
				<Updater />
				<FiltersApp
					isServer={__SERVER__}
					atlassianAccountId={atlassianAccountId ? toAccountId(atlassianAccountId) : undefined}
					// @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string'.
					xsrfToken={xsrfToken}
					query={query}
					favoriteChangeContext={favoriteChangeContext}
					prefetchedData={data}
					onQueryChanged={onQueryChanged}
					onUnmount={noop}
					withPageReadyMetrics={false}
					withoutHeader={false}
				/>
				{/* @ts-expect-error - TS2769 - No overload matches this call. */}
				<SubmitApdex
					metricKey="jira.directories.filters"
					metric={filtersDirectoryPageLoad}
					isExpectedToHaveSsr
					withMarks={[appBundleReadyMark, prefetchApiReadyMark]}
				/>
			</ReportErrors>
		</PageLayout>
	);
}

export default AnalyticsSource('filters', SCREEN)(FiltersDirectory);
